module.exports = __webpack_public_path__ + "media/images/common/nav_number-3439bd1a0e08f59511eae01c40aa03bd.gif";